module.exports = __webpack_public_path__ + "img/mobile-header.2aaca200.svg";